import { render, staticRenderFns } from "./RejectDialog.vue?vue&type=template&id=6cbabdc4&scoped=true&lang=pug&"
import script from "./RejectDialog.vue?vue&type=script&lang=ts&"
export * from "./RejectDialog.vue?vue&type=script&lang=ts&"
import style0 from "./RejectDialog.vue?vue&type=style&index=0&id=6cbabdc4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cbabdc4",
  null
  
)

component.options.__file = "RejectDialog.vue"
export default component.exports